'use strict';

angular.module('amexReconciliationApp')
  .component('transactionToolbar', {
    templateUrl: 'scripts/views/directives/transaction-toolbar.html',
    controller: function (BillingCycleModel,
                          TransactionSearchModel,
                          TransactionsModel,
                          AccountListService,
                          UserModel,
                          ReceiptService,
                          SiteConfigModel) {
      var self = this;

      self.userRoles = UserModel.roles;
      self.currentRole = TransactionSearchModel.role;

      self.billingCycles = BillingCycleModel.billingCycles;
      self.currentBillingCycle = TransactionSearchModel.billingCycle;
      self.isBcaManager = TransactionSearchModel.isBcaManager;
      self.isAccountingManager = TransactionSearchModel.isAccountingManager;
      self.isCardManager = TransactionSearchModel.isCardManager;
      self.isCardMember = TransactionSearchModel.isCardMember;
      self.UserModel = UserModel;
      self.cardmemberDetails = getCardMemberDetails;
      self.siteName = SiteConfigModel.siteName;
      self.TransactionsModel = TransactionsModel;

      self.currentBillingCycleSiteSummaries = function() {
        return _.get(TransactionSearchModel.billingCycle(), 'siteSummaries', null);
      };

      self.showBillingCycleTotal = function() {
        return !(TransactionSearchModel.isBcaManager()
        || TransactionSearchModel.isAccountingManager()
        || TransactionSearchModel.isCardManager());
      };


      self.accountingLineName = function () {
        return _.get(TransactionSearchModel.accountingLine(), 'name', '');
      };

      self.concatValue = function () {
        return _.get(TransactionSearchModel.accountingLine(), 'concatValue', '');
      };

      self.roleChanged = function() {
        self.goToAccounts();
      };

      self.goToAccounts = function () {
        AccountListService.roleChange(self.currentRole());
      };

      self.displayUploadReceiptsToCycleButton = function() {
        return (
          SiteConfigModel.transactionReceiptsEnabled() &&
          readyForReceipts() &&
          !TransactionSearchModel.isBcaManager() &&
          !TransactionSearchModel.isLimitedRole()
        );
      };

      self.displayCycleReceiptsButton = function() {
        return SiteConfigModel.cycleReceiptsEnabled() && readyForCycleReceipts();
      };

      self.displayCycleMatchedReceiptsButton = function () {
        return (
          SiteConfigModel.transactionReceiptsEnabled() &&
          (TransactionSearchModel.isBcaManager() || TransactionSearchModel.isAccountingManager())
        );
      };

      function readyForReceipts() {
        return !ReceiptService.receiptUploadingIsLocked() && readyForCycleReceipts();
      }

      function readyForCycleReceipts() {
        return !_.isEmpty(self.currentBillingCycle()) &&
        !TransactionSearchModel.isAccountingManager();
      }

      function getCardMemberDetails() {
        var cardNumber =  _.get(TransactionSearchModel.card(), 'decryptedCardNumber', '');
        var cardMemberName = _.get(TransactionSearchModel.card(), 'cardMemberName', '');

        return cardMemberName + ' (' + cardNumber + ')';
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/transactionToolbar.js
// module id = 540
// module chunks = 0